import { ideaResult } from '@/services/result-service'
import { computed } from 'vue'
import { useRouter } from 'vue-router';
import { reportService } from '@/services/report-service'
import { size } from 'lodash'
import type { IBaseSolution } from '@/types';

export function useResultReport() {
    const solutions = computed(() => {
        return ideaResult.value.results
    })
    /**
     * 用户手动勾选加入报告的数量
     */
    const userCheckedReportTotal = computed(() => {
        return size(solutions.value.filter(f => f.addedReport))
    })

    /**
     * 用于报告确认弹窗里面的列表
     */
    const userConfirmReportList = computed(() => {
        solutions.value.forEach((e, i) => {
            e.order = i + 1;
        });
        if (userCheckedReportTotal.value) {
            return solutions.value.filter(f => f.addedReport)
        } else {
            /**
             * 如果用户没有手动勾选，那么系统自动推荐前5条
             */
            return solutions.value.slice(0, 5)
        }
    })

    const router = useRouter();

    function toggleIntoReportList(currentPatent: IBaseSolution) {
        /**
         * 当用户手动勾选的时候，如果有之前系统推荐的5个，则清除之前的。
         */
        if (userCheckedReportTotal.value < 1 && reportService.value.reportList.length) {
            reportService.value.reportList = [];
        }
        ideaResult.value.toggleIntoReportList(currentPatent)
    }

    function handleRemove(item: IBaseSolution) {
        toggleIntoReportList(item)
    }

    function handleGoReport(confirmedList: IBaseSolution[]) {
        if (!confirmedList.length) { return }
        reportService.value.reportList = confirmedList
        router.push({
            name: 'report',
        });
    }

    return {
        userConfirmReportList,
        userCheckedReportTotal,
        handleGoReport,
        handleRemove,
        toggleIntoReportList,
    }
}
